import image1 from './images/Research@4x-5.png'
import image2 from './images/Research@4x-2.png'
import image3 from './images/Research@4x-1.png'
import image4 from './images/Research@4x-4.png'
import image5 from './images/Research@4x.png'
import image6 from './images/Research@4x-3.png'

export const Data = [
  {
     icon: image1,
     title: "Presentation Design",
     text:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nostrum, voluptatum voluptates voluptatem." 
  },
  {
     icon: image2,
     title: "Audio-Visual Production",
    text:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nostrum, voluptatum voluptates voluptatem." 
  },
  { 
    icon: image3, 
    title: "Translation Services", 
    text:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nostrum, voluptatum voluptates voluptatem." 
  },
  { 
    icon: image4,
    title: "Graphic Design", 
    text:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nostrum, voluptatum voluptates voluptatem."
  },
  { 
    icon: image5, 
    title: "Research & Analytics", 
    text:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nostrum, voluptatum voluptates voluptatem."
   },
  { 
    icon: image6,
    title: "Data Processing",
    text:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Nostrum, voluptatum voluptates voluptatem."
   }
];